module.exports = __webpack_public_path__ + "img/icon_app_version.8933d5ce.png";